// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"82e26099ea1c1b8c","src_app_documents_documents_module_ts":"f88033721a0e165c","src_app_catalog_catalog_module_ts":"29dafb27bd69ca79"}[chunkId] + ".js";
};